import styled from 'styled-components';
import { Autocomplete } from '@mui/material';

import StyledChip from '../../../../../../../../components/v2/Chip';
import colors from '../../../../../../../../styles/colors';
import { fontFamily } from '../../../../../../../../styles/text';

const FieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 10px 24px;
`;

const HelperText = styled.span`
  font-family: ${fontFamily.sansSerif};
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
`;

const StyledAutocomplete = styled(Autocomplete)`
  width: 100%;

  .MuiInputBase-root {
    font-size: 14px;
  }
`;

/*
 * Doubled selector: MUI's own option class sets align-items on this element, and with the column
 * direction below that is what centres the name and chips instead of stacking them on the left.
 */
const OptionRow = styled.li`
  && {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    text-align: left;
    gap: 4px;
  }
`;

const OptionName = styled.span`
  font-family: ${fontFamily.sansSerif};
  font-size: 14px;
  font-weight: 500;
`;

const OptionChips = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;

const OptionChip = styled(StyledChip)`
  margin: 2px 4px 2px 0;
  padding: 0 4px;
  height: 22px;
  font-size: 11.5px;
`;

const AcceptUntilChip = styled(OptionChip)`
  background: ${colors.shades.warning1};
`;

export {
  AcceptUntilChip,
  FieldContainer,
  HelperText,
  OptionChip,
  OptionChips,
  OptionName,
  OptionRow,
  StyledAutocomplete,
};
